import { FC } from 'react';
import { Col, Row } from 'antd';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { WithTranslation, withTranslation } from 'react-i18next';

import { Mobile, PageContentContainer, Web } from '~src/styles/containers.sc';
import MobileLogoutButton from '~src/shared/buttons/MobileLogoutButton';
import { StoreI } from '~src/rootReducer';
import { ButtonSizes } from '~src/shared/buttons/basicButtons/BaseButton.sc';
import { routes } from '~src/routingConfig';
import { isAdmin } from '~src/store/session/session.reducer';
import SvgPicture from '~src/shared/SvgPicture';

import {
  LogOutContainer,
  LoopPicture,
  SuccessMessage,
  SuccessSubTitle,
  SuccessTitle,
} from './cards/redirectCard.sc';
import { CardsContainer } from './shared.sc';
import { MsgButton, NoSurveyContainer } from './NoSurvey.sc';

interface StateProps {
  isAdmin: boolean;
  simpleGui: boolean;
}

type Props = StateProps & WithTranslation;

const NoSurvey: FC<Props> = props => {
  const { t } = props;
  const isAdminString = `${props.isAdmin ? '.admin' : ''}`;
  return (
    <NoSurveyContainer>
      <CardsContainer>
        <PageContentContainer>
          <Row>
            <Col lg={{ span: 8, offset: 8 }} xs={{ span: 24, offset: 0 }}>
              <SuccessMessage>
                <LoopPicture>
                  <SvgPicture name="loopCongrats" />
                </LoopPicture>
                <Web>
                  <SuccessTitle data-translation={`x.questions.no_survey.header${isAdminString}`}>
                    {t(`x.questions.no_survey.header${isAdminString}`)}
                  </SuccessTitle>
                </Web>
                {(!props.simpleGui || props.isAdmin) && (
                  <Web>
                    <SuccessSubTitle
                      data-translation={`x.questions.no_survey.header.subtitle${isAdminString}`}
                    >
                      {t(`x.questions.no_survey.header.subtitle${isAdminString}`)}
                    </SuccessSubTitle>
                  </Web>
                )}
                <Mobile>
                  {!props.simpleGui || props.isAdmin ? (
                    <SuccessSubTitle data-translation="x.questions.no_survey.header.subtitle.mobile">
                      {t('x.questions.no_survey.header.subtitle.mobile')}
                    </SuccessSubTitle>
                  ) : (
                    <SuccessSubTitle data-translation={`x.questions.no_survey.header${isAdminString}`}>
                      {t(`x.questions.no_survey.header${isAdminString}`)}
                    </SuccessSubTitle>
                  )}
                </Mobile>
                {(!props.simpleGui || props.isAdmin) && (
                  <Link to={props.isAdmin ? routes.analysis.heatmap : routes.reports.sessionUser}>
                    <MsgButton $buttonSize={ButtonSizes.Wide} $buttonColor="white">
                      <span data-translation={`x.questions.no_survey.button.view_profile${isAdminString}`}>
                        {t(`x.questions.no_survey.button.view_profile${isAdminString}`)}
                      </span>
                    </MsgButton>
                  </Link>
                )}
              </SuccessMessage>
            </Col>
          </Row>
        </PageContentContainer>
        <LogOutContainer $moreQuestions={false}>
          <MobileLogoutButton t={t} />
        </LogOutContainer>
      </CardsContainer>
    </NoSurveyContainer>
  );
};

const mapStateToProps = (state: StoreI): StateProps => ({
  isAdmin: isAdmin(state),
  simpleGui: state.user.session.company ? state.user.session.company.simple_gui : false,
});

const NoSurveyWithTranslation = withTranslation()(NoSurvey);
const NoSurveySuperComponent = connect(mapStateToProps)(NoSurveyWithTranslation);
export default NoSurveySuperComponent;
